import { createApp } from 'vue'
import App from './App.vue'
import routeConf from './router/routeConf'
import '../static/css/main.css'
import '../static/css/markdown.css'
import 'qs3_icon'
import qs3_pc_base from 'qs3_pc_base'
import loadingDirective from '../src/views/common/directive/loading/directive'
import cancelModelDirective from '../src/views/common/directive/cancelModel/cancelModel'
import uploadOp from '../src/views/common/upload/uploadOp'
import authOp from '../src/views/common/auth/auth'

import ElementPlus from 'element-plus';
import { zhCn } from 'element-plus/es/locale'
import api  from './api/api'
import lowVer from "../src/views/common/tips/lowVer.vue"
import avatarDirective from './views/common/directive/avatarImg/directive'

// 只导入一次 Element Plus 样式（选择其中一种方式）
// 方式1：使用编译后的 CSS（推荐，避免 SCSS 编译问题）
import 'element-plus/dist/index.css'

// 方式2：如果必须使用 SCSS 源码（取消下面的注释，同时注释上面的）
// import 'element-plus/theme-chalk/src/index.scss'

// 导入自定义主题样式
import '../static/theme/theme.scss'

qs3_pc_base.i18n.loadLanguage().then((i18n)=>{
    const app = createApp(App)
    app.config.devtools = true
    app.config.globalProperties.$uploadOp = uploadOp;
    app.config.globalProperties.$authOp = authOp;
    app.use(i18n)
    .use(loadingDirective)
    .use(avatarDirective)
    .use(cancelModelDirective)
    .use(api).
    use(qs3_pc_base).use(routeConf.router).use(ElementPlus, {locale: zhCn,size: 'large'}).component('lowVer',lowVer).mount('#app')
    routeConf.setVue(app)
})